/*
 * Module for the Insurance Carriers' Rates view
*/

rs.module("fund/configuration/insurancecarriers/ratemassupdate",

    ["common/select-helper", "controls/components/event-banner"],

    function (selectHelper, eventBanner) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls) {

            var form = $.js(jsSelectors.updateOptionsForm);

            //
            // reload rate tiers when insurance type is changed (this is for the form, above is for the filter)
            //
            form.js(jsSelectors.insuranceTypeSelect).change(function () {
                selectHelper.getHelper(form.js(jsSelectors.insuranceRateTierSelect)).loadOptionsFrom(
                    backendUrls.getRateTiers,
                    {
                        insuranceTypeKey: $(this).val()
                    },
                    {
                        withBlank: false
                    }
                );  

                clearErrors();
            });           
            
            //
            // Clear event banner and field errors
            //
            function clearErrors() {
                // clear event banner
                eventBanner.removeAllMessages();

                // clear field errors
                form.js(jsSelectors.insuranceTypeSelect).clearErrors();
                form.js(jsSelectors.insuranceRateTierSelect).clearErrors();                
                form.js(jsSelectors.effectiveDate).clearErrors();
                form.js(jsSelectors.terminationDate).clearErrors();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);